<template>
    <!-- <div class="modalDialog is-active" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="modalClose"> -->
    <div class="reviewBox" @keyup.esc="modalClose">
        <div>
            <a title="Close" class="close" @click="closeBox">X</a>
            <h4>Timecard Review</h4>
            <hr />
        </div>
        <div v-for="choice in reviewOptions" :key="choice.id">
            <div v-if="choice.show">
                <div class="col-xs-1"><input class="right" v-model="reviewOption" type="radio" :value="choice.id"/></div>
                <div class="col-xs-11 option">{{ choice.label }}</div>
                <div class="col-xs-1"></div>
                <div class="col-xs-11 info" v-html="choice.description"></div>
                <div v-if="choice.selections">
                    <div class="col-xs-1"></div>
                    <div v-if="reviewOption === 6" class="col-xs-10">
                        <select class="form-control m-left-20" v-model="kickbackApproverId">
                            <option value="">Select One:</option>
                            <option v-for="option in choice.selections" :key="option.id" :value="option.id">{{ option.user }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        <div class="m-top-10">
            <span class="bold">Add an Optional Review Comment</span>
            <textarea class="form-control" name="comments" v-model="comments" rows="3" id="comments" placeholder="Add an optional review comment. No other person will see this review."></textarea>
        </div>
        <div class="clear"></div>
        <hr />
        <div class="right">
            <span v-if="buttonNo">
                <button class="btn btn-default m-right-10" @click="closeBox"><span v-if="buttonNoLabel">{{buttonNoLabel}}</span><span v-else>Cancel</span></button>
            </span>
            <span v-if="buttonYes">
                <button class="btn btn-primary" @click="confirm"><span v-if="buttonYesLabel">{{buttonYesLabel}}</span><span v-else>{{ this.nextTimecard ? "Save and Next" : "Save Review" }}</span></button>
            </span>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
export default defineComponent ({
    name: 'TimecardReviewBox',
    emits: ['close', 'save'],
    props: {
        data: {
            type: Object,
            default: {}
        },

        showBatches: {
            type: Boolean,
            default: false,
            required: false
        },

        approver: {
            type: Boolean,
            default: false,
            required: false
        },

        nextApprover: {
            type: Boolean,
            default: false,
            required: false
        },

        bypass: {
            type: Boolean,
            default: false,
            required: false
        },

        reviews: {
            type: Object,
            required: false,
            default () {
                return []
            }
        },

        nextTimecard: {
            type: String,
            default: undefined,
            required: false
        },

        previousApprovals: {
            type: Array,
            required: false,
            default () {
                return []
            }
        },

        buttonNo: {
            default: true
        },

        buttonYes: {
            default: true
        },

        buttonNoLabel: {
            type: String,
            required: false,
        },

        buttonYesLabel: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            reviewTypeId: '',
            addBatch: true,
            comments: '',
            reviewOption: 1,
            reviewOptions: [
                {
                    id: 1,
                    label: "Reviewed",
                    description: "Mark as reviewed" + (this.nextTimecard ? " and go to the next timecard" : "") + ". Keeps timecard in your &ldquo;To Approve&rdquo; page.",
                    show: true,
                },
                {
                    id: 2,
                    label: "Reviewed and Approved",
                    description: "Mark as reviewed and approved, sends to the next approver tier" + (this.nextTimecard ? ", and go to the next timecard" : "") + ".",
                    show: this.approver && this.nextApprover,
                },
                {
                    id: 3,
                    label: "Reviewed and Bypass to Final Approval",
                    description: "Mark as reviewed and approved, and timecard is ready for submission to Revolution.",
                    show: this.approver && this.bypass,
                },
                {
                    id: 4,
                    label: "To Review",
                    description: "Flag for review" + (this.nextTimecard ? " and go to the next timecard" : "") + ". Keeps timecard in your &ldquo;To Approve&rdquo; page.",
                    show: true,
                },
                {
                    id: 5,
                    label: "Return to Employee",
                    description: "Send back to the employee to fix the timecard.",
                    show: true,
                },
                {
                    id: 6,
                    label: "Return to Previous Approver",
                    description: "Send back to an earlier approver to review and reapprove.",
                    selections: this.previousApprovals,
                    show: this.previousApprovals && this.previousApprovals.length > 0,
                },
            ],
            kickbackApproverId: '',
        }
    },

    methods: {
        closeBox(event) {
            this.$emit('close');
        },

        confirm(event) {
            if (this.reviewOption === 6 && !this.kickbackApproverId) {
                alert('Please choose who you want to kick the timecard back to.');
                return;
            }
            this.closeBox();
            const reviewType = this.reviewOption <= 3 ? 'TC_APPROVED' : (this.reviewOption === 4 ? 'TC_REVIEW' : 'TC_RETURNED');
            const data = {
                type: reviewType,
                comments: this.comments,
                kickback: this.reviewOption === 5, // Don't save the review if kicked back to employee
                approve: (this.reviewOption === 2 || this.reviewOption === 3) ? true : false, // This sends to the next employer
                bypass: this.reviewOption === 3 ? true : false, // This bypasses remaining approvers
                kickbackApprovalId: this.reviewOption === 6 ? this.kickbackApproverId : false, // Send approver back..
            };
            this.$emit('save', data);
        },
    },
    created() {
    },
    mounted () {
        if (this.reviews && this.reviews.length && this.reviews[0].comments) this.comments = this.reviews[0].comments;
    }
});
</script>

<style>
.reviewBox {
    position: absolute;
    right: 100px;
    z-index: 1000;
    border: 2px solid red;
    border-radius: 10px;
    box-shadow: 2px 20px 40px 30px #666;
    padding: 20px;
    background-color: white;
    max-width: 900px;
}
.option {
    font-size: 1.1em;
    font-weight: bold;
    text-decoration: underline;
}
.info {
    font-weight: lighter;
}
</style>